import { create } from 'zustand';

/**
 * État d'interface global, hors données serveur.
 *
 * Les données de l'API vivent dans le cache de TanStack Query ; ce store ne garde que ce qui
 * n'appartient à aucune requête : l'état de session vu par l'interface, la bascule en
 * maintenance, et les quelques valeurs qu'un écran transmet à un autre.
 */
interface UiState {
    /** Utilisateur chargé et autorisé : c'est ce drapeau qui ouvre les routes privées. */
    login: boolean;
    /** Le Pass a répondu 503 : l'application bascule sur la page de maintenance. */
    maintenance: boolean;
    /** Retour de la dernière déclaration de sinistre, affiché sur l'écran de confirmation. */
    postAccidentResponse: unknown;
    /** Réduction calculée par le simulateur d'hivernage. */
    hivernageReduction: unknown;
    /** Code promo obtenu par l'utilisateur, affiché une fois demandé. */
    codePromoUser: unknown;
    setLogin: (login: boolean) => void;
    setMaintenance: (maintenance: boolean) => void;
    setPostAccidentResponse: (response: unknown) => void;
    setHivernageReduction: (reduction: unknown) => void;
    setCodePromoUser: (code: unknown) => void;
}

export const useUiStore = create<UiState>()((set) => ({
    login: false,
    maintenance: false,
    postAccidentResponse: undefined,
    hivernageReduction: undefined,
    codePromoUser: null,
    setLogin: (login) => set({ login }),
    setMaintenance: (maintenance) => set({ maintenance }),
    setPostAccidentResponse: (postAccidentResponse) => set({ postAccidentResponse }),
    setHivernageReduction: (hivernageReduction) => set({ hivernageReduction }),
    setCodePromoUser: (codePromoUser) => set({ codePromoUser }),
}));
